/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { AnalyticsInt } from "./types";
import { HomeAPI } from "../../services/home/index";

export const actions: ActionTree<AnalyticsInt, RootState> = {
  getAnalytics({ commit }) {
    return new Promise((resolve, reject) => {
      HomeAPI.getAnalytics()
        .then((res: any) => {
          resolve(false);
          commit("ANALYTICS_FULLFILED", res.data);
        })
        .catch((err) => {
          reject(true);
          commit("ANALYTICS_REJECTED", err);
        });
    });
  },
};
